import TickerBar from "@/pages/home/components/TickerBar";
import SiteNav from "@/pages/home/components/SiteNav";
import HeroSection from "@/pages/home/components/HeroSection";
import HotBoard from "@/pages/home/components/HotBoard";
import LatestFeed from "@/pages/home/components/LatestFeed";
import ForumBoards from "@/pages/home/components/ForumBoards";
import GroupEntry from "@/pages/home/components/GroupEntry";
import LiveTimeline from "@/pages/home/components/LiveTimeline";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import TagCloudSection from "@/pages/home/components/TagCloudSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <TickerBar />
      <SiteNav />
      <main>
        <HeroSection />
        <HotBoard />
        <LatestFeed />
        <ForumBoards />
        <GroupEntry />
        <LiveTimeline />
        <GuideSection />
        <FaqSection />
        <TagCloudSection />
      </main>
      <SiteFooter />
    </div>
  );
}